import { Environment, EnvironmentName } from 'src/app/core/models/environment.models';

export const environment: Environment = {
  name: EnvironmentName.DEV,
  authSessionTime: 15 * 60 * 1000,
  apiUrl: 'https://greenroom-env.napacenter.org/api',
  baseUrl: 'https://greenroom-env.napacenter.org',
};
